import { render, staticRenderFns } from "./EmployeeFaceFormList.vue?vue&type=template&id=bf9efa2e"
import script from "./EmployeeFaceFormList.vue?vue&type=script&lang=js"
export * from "./EmployeeFaceFormList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports